import { useContent } from "../hooks/useContent";
import { useInView } from "../hooks/useInView";
import { WHATSAPP_URL, PHONE } from "../data/mock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FAQSection = () => {
  const [ref, isInView] = useInView();
  const { getSection } = useContent();
  const faqs = getSection("faqs") || [];

  return (
    <section id="faq" className="py-16 lg:py-20 bg-slate-50/70 relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16">
          <div ref={ref} className="lg:sticky lg:top-32 lg:self-start">
            <span className="inline-block text-sm font-semibold text-sky-600 tracking-wider uppercase mb-4">
              Got Questions?
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-5">
              Frequently Asked
              <br />Questions
            </h2>
            <p className="text-lg text-slate-500 leading-relaxed mb-8">
              Everything you need to know about Blitzwash. Can't find what you're looking for? Reach out to our team.
            </p>
            <div className="flex items-center gap-4">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-3 bg-sky-600 text-white rounded-xl font-semibold text-sm hover:bg-sky-700 shadow-lg shadow-sky-600/20 transition-all duration-300">
                Chat on WhatsApp
              </a>
              <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 px-5 py-3 border border-slate-200 text-slate-700 rounded-xl font-semibold text-sm hover:bg-white hover:border-slate-300 transition-all duration-300">
                Call Us
              </a>
            </div>
          </div>

          <div className={`transition-all duration-700 ${isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="bg-white rounded-xl border border-slate-100 px-6 data-[state=open]:border-sky-200 data-[state=open]:shadow-md data-[state=open]:shadow-sky-900/5 transition-all duration-300"
                >
                  <AccordionTrigger className="text-left text-base font-semibold text-slate-900 hover:text-sky-600 py-5 hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-slate-500 leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
